import React from 'react';
import logo from '../../assets/image/logo.png';
import chessimg5 from '../../assets/image/chessimg14.jpeg';
import constructor_1 from '../../assets/image/constructor_1.jpg';
import constructor_2 from '../../assets/image/constructor_2.jpg';
import constructor_3 from '../../assets/image/constructor_3.jpg';



const Achivement = () => {
    return (
        <div className="achivement-page">
            <div id="preloader-active">
                <div className="preloader d-flex align-items-center justify-content-center">
                    <div className="preloader-inner position-relative">
                        <div className="preloader-circle"></div>
                        <div className="preloader-img pere-text">
                            <img src={logo} alt="Loading..." />
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <main>
                {/* Hero Section */}
                <div className="slider-area">
                    <div
                        className="single-slider hero-overly slider-height d-flex align-items-center"
                        style={{
                            backgroundImage: `url(${chessimg5})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px',
                        }}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="hero-cap">
                                        <h2>Achievements</h2>
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                                <li className="breadcrumb-item"><a href="#">Achievement</a></li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <section className="team-section">
                    <div className="container">
                        <div className="section-header">
                            <div className="header-left">
                                <div className="subtitle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="15" viewBox="0 0 11 15" fill="none">
                                        <path d="M3.14286 10L0 15L8.78104e-07 0L3.14286 5V10Z" fill="#EA5501"></path>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.28571 10L3.14286 15L3.14286 10L4.71428 7.5L3.14286 5L3.14286 0L6.28571 5L6.28571 10ZM6.28571 10L7.85714 7.5L6.28571 5V0L11 7.5L6.28571 15V10Z" fill="#EA5501"></path>
                                    </svg>
                                    Engineer
                                </div>
                                <h2 className="section-title">The Best Industry Expert</h2>
                            </div>
                        </div>

                        <div className="team-cards-row">
                            
                            <div className="team-card">
                                <div className="card-image cut-corner">
                                    <img src={constructor_1} alt="Peter Reze" />
                                </div>
                                <div className="card-content">
                                    <h5 className="card-title">Peter Reze</h5>
                                    <span className="card-designation">St. Engineer</span>
                                </div>
                            </div>

                            {/* Team Member 2 */}
                            <div className="team-card">
                                <div className="card-image cut-corner">
                                    <img src={constructor_2} alt="Jack Peter" />
                                </div>
                                <div className="card-content">
                                    <h5 className="card-title">Jack Peter</h5>
                                    <span className="card-designation">Four Mon</span>
                                </div>
                            </div>

                            {/* Team Member 3 */}
                            <div className="team-card">
                                <div className="card-image cut-corner">
                                    <img src={constructor_3} alt="Bradley Ray" />
                                </div>
                                <div className="card-content">
                                    <h5 className="card-title">Bradley Ray</h5>
                                    <span className="card-designation">St. Engineer</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CSS Styling Below */}
                    <style>
                        {`
.team-section {
    padding: 80px 0;
    background: #fff;
    font-family: 'Arial', sans-serif;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.section-header {
    margin-bottom: 60px;
    text-align: left;
}

.subtitle {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #EA5501;
}

.section-title {
    font-size: 42px;
    font-weight: 700;
    margin: 0;
    color: #000;
    line-height: 1.2;
}

.team-cards-row {
    display: flex;
    gap: 30px;
    justify-content: center;
      flex-wrap: nowrap; /* 🔄 Don't wrap to next line */
    overflow-x: auto;
}

.team-card {
    background: #fff;
    text-align: center;
    width: 380px;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    position: relative;
}

.team-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.team-card::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0%;
    height: 2px;
    background-color: #EA5501;
    transition: width 0.3s ease-in-out;
}

.team-card:hover::after {
    width: 100%;
}

.card-image {
    position: relative;
    width: 100%;
    height: 440px;
    overflow: hidden;
}

.card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
clip-path: polygon(0 0, 80% 0, 100% 20%, 100% 85%, 0% 100%);
    transition: transform 0.3s ease, clip-path 0.3s ease;
}



.card-content {
    padding: 5px 5px 10px;
}

.card-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 4px 0;
    color: #000;
    position: relative;
}

.card-designation {
    color: #555;
    font-size: 14px;
    font-weight: 400;
}

@media (max-width: 768px) {
    .team-cards-row {
        flex-direction: column;
        align-items: center;
        gap: 40px;
    }

    .section-title {
        font-size: 32px;
        text-align: center;
    }

    .subtitle {
        justify-content: center;
        color: orange
    }
}
        `}
                    </style>
                </section>





            </main>
            <div id="back-top" style={{ textAlign: 'center' }}>
                <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
                    <i className="fas fa-level-up-alt"></i>
                </a>
            </div>
        </div>
    )
}

export default Achivement;